import { KdsButton, KdsText } from "@kazaar-platform/design-system";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { injectDataCy } from "@/helpers/injectDataCy";
import { userAtom } from "@/store";
import { type States, useStatesProps } from "./utils";

export const SimplePage = ({ state }: { state: States }) => {
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);
  const { title, description, icon, button } = useStatesProps(state);

  useEffect(() => {
    if (state === "403") {
      console.warn("missing_permission", user?.permissions);
    }
  }, []);

  return (
    <div
      className="flex h-screen w-2/3 bg-white"
      {...injectDataCy(`error${state}Page`)}
    >
      <div className="flex w-full items-center justify-center p-sp-xl3">
        <div className="flex w-1/2 flex-col items-start justify-center gap-sp-xl text-text-body">
          {icon}

          <div className="flex flex-col gap-sp-xl">
            <div className="flex flex-col gap-4">
              <KdsText size="display-lg">{title}</KdsText>
              <KdsText>{description}</KdsText>
            </div>

            {button && Object.keys(button).length && (
              <KdsButton
                variant="contained"
                onPress={
                  button?.onPress
                    ? button.onPress
                    : () => {
                        void navigate(button?.link || "/");
                      }
                }
              >
                {button.label}
              </KdsButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
